import { cn } from 'root/src/client/v2/common/helpers/cn';
// Shared typography container for reused legacy static-page JSX (legal pages, FAQ answers). The legacy
// content blocks are raw elements (`<p>`, `<ul>/<li>`, `<strong>/<span>` definition pairs, `<a>` mailto
// / external links, the react-scroll `Anchor` which renders an `<a>`) with no per-element classes. This
// wrapper styles them via descendant selectors so the verbatim content picks up redesign tokens: body
// in muted foreground, links in `neon-cyan` (matching the notification markdown link treatment). Zero
// layout shift: only static text is styled, nothing animates here.
export const ContentProse = ({ children, className, definitionStrong }) => (<div className={cn('text-[15px] leading-relaxed text-muted-foreground', 
    // Paragraph rhythm.
    '[&_p]:mb-4 [&_p]:last:mb-0', 
    // Strong: foreground weight. Inline by default; block sub-heading when `definitionStrong` is set
    // (legacy `strong { display: block }` definition lists).
    '[&_strong]:font-semibold [&_strong]:text-foreground', definitionStrong && '[&_strong]:mt-4 [&_strong]:block', 
    // Inline emphasis used mid-sentence (bold / italic) stays the foreground colour.
    '[&_b]:font-semibold [&_b]:text-foreground [&_em]:text-foreground [&_i]:text-foreground', 
    // Lists.
    '[&_li]:marker:text-muted-foreground', 
    // Links (mailto, external, the react-scroll TOC / section anchors): neon-cyan underline.
    '[&_a]:font-medium [&_a]:text-neon-cyan [&_a]:underline [&_a]:underline-offset-2 [&_a]:transition-opacity hover:[&_a]:opacity-80', className)}>
		{children}
	</div>);
